export const globalInitialState: any = {};
